
<template>
  <div class="telemetria-kontrow-indicadores ml-4 mr-4">
    <b-form>
      <b-row>
        <!-- -->
        <b-col cols="5">
          <label for="select-empresa">Empresa</label>
          <multiselect
            id="selecao-empresa-sol"
            v-model="value_empresa"
            required
            :options="empresas"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            @close="loadEventos()"
            :preserve-search="true"
            placeholder="Selecione a empresa"
            label="empresa"
            track-by="empresa"
            name="empresa"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} Empresa selecionada</span
              ></template
            >
          </multiselect>
        </b-col>

        <b-col cols="4">
          <label for="select-garagem_sol">Eventos</label>
          <multiselect
            id="selecao-evento-tele"
            v-model="value_eventos"
            required
            :options="eventos"
            :multiple="true"
            :taggable="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Selecione o(s) evento(s)"
            label="evento"
            track-by="evento"
            name="evento"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} Evento selecionado</span
              ></template
            >
          </multiselect>
        </b-col>

        <b-col cols="1">
          <div>
            <label for="datepicker-placeholder">Data inicial</label>
            <b-form-datepicker
              id="dt_sol_inicial"
              required
              v-model="dt_inicial_operacao"
              placeholder="Data inicial "
              locale="pt-BR"
              date-format-options="DD/MM/YYYY"
            ></b-form-datepicker>
          </div>
        </b-col>

        <b-col cols="1">
          <div>
            <label for="datepicker-placeholder">Data final</label>
            <b-form-datepicker
              id="dt_sol_final"
              required
              v-model="dt_final_operacao"
              @input="loadScoreEventos()"
              placeholder="Data do final"
              locale="pt-BR"
              date-format-options="DD/MM/YYYY"
            ></b-form-datepicker>
          </div>
        </b-col>

        <b-col cols="1" class="mt-4">
          <b-button
            size="sm"
            id="btn-pesquisar"
            variant="success"
            block
            class="mr-2 mt-1"
            @click="
              loadKpiDia(),
                loadKpiFuncionario(),
                loadKpiEventos(),
                loadKpiLinhas()
            "
          >
            <b-spinner v-if="carregando" small style="margin-bottom: 3px">
            </b-spinner>
            Filtrar gráfico
          </b-button>
        </b-col>

        <LoadingModal v-if="isLoading" />
      </b-row>
    </b-form>

    <!-- Painel -->
    <!-- Painel -->
    <!-- Painel -->

    <template>
      <div>
        <!-- diário  -->
        <b-row>
          <b-col cols="12" class="mt-4" id="grafdia">
            <apexcharts
              ref="chartdia"
              height="400"
              :options="graficoDia"
              :series="seriesdia"
            >
            </apexcharts>
          </b-col>
        </b-row>

        <!-- acumulado  -->
        <b-row>
          <!-- acumulado  eventos -->
          <b-col cols="4">
            <apexcharts
              ref="chartdepto"
              height="400"
              :options="graficoDepto"
              :series="seriesdepto"
            ></apexcharts>
          </b-col>

          <!-- acumulado  operador -->
          <b-col cols="4">
            <apexcharts
              ref="chartfuncionario"
              height="400"
              :options="graficoFuncioanrio"
              :series="seriesfuncionario"
            ></apexcharts>
          </b-col>

          <!-- acumulado  linha -->
          <b-col cols="4">
            <apexcharts
              ref="chartlinha"
              height="400"
              :options="graficoLinha"
              :series="serieslinha"
            ></apexcharts>
          </b-col>
        </b-row>
      </div>
    </template>

    <!-- Painel -->
    <!-- Painel -->
    <!-- Painel -->
  </div>
</template>


<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import Multiselect from "vue-multiselect";
import moment, { now } from "moment";
import { mapState } from "vuex";
import LoadingModal from "../utilitarios/LoadingModal";
import VueApexCharts from "vue-apexcharts";
//import { onBeforeUpdate } from 'vue'

export default {
  name: "SolicitacaoPainel",

  components: {
    apexcharts: VueApexCharts,
    Multiselect,
    LoadingModal,
  },
  computed: { ...mapState(["user"]) },

  data: function () {
    return {
      /* diario */
      graficoDia: {
        chart: {
          id: "bar-dia",
          type: "bar",
          height: 350,

          foreColor: "black",
          toolbar: {
            show: false,
          },
        },
        xaxis: {
          categories: [],
          tickPlacement: "of",
        },
        title: {
          text: "Eventos diários",
          align: "center",
          margin: 10,
          offsetX: 0,
          offsetY: 0,
          floating: false,
          style: {
            fontSize: "22px",
            fontWeight: "bold",
            color: "#263238",
          },
        },
      },

      /* Departamento    */
      graficoDepto: {
        chart: {
          id: "bar-departamento",
          type: "bar",
          height: 350,

          foreColor: "black",
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            //barWidth: '10%'  // Defina a altura das barras (porcentagem do tamanho total)
          },
        },
        xaxis: {
          labels: {
            maxWidth: 400, // Define uma largura máxima para os rótulos
          },
          categories: [],
          tickPlacement: "of",
        },
        title: {
          text: "Eventos",
          align: "center",
          margin: 10,
          offsetX: 0,
          offsetY: 0,
          floating: false,
          style: {
            fontSize: "22px",
            fontWeight: "bold",
            color: "#263238",
          },
        },
      },

      /* linhas    */
      graficoLinha: {
        chart: {
          id: "bar-linhas",
          type: "bar",
          height: 350,

          foreColor: "black",
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            //barWidth: '10%'  // Defina a altura das barras (porcentagem do tamanho total)
          },
        },
        xaxis: {
          labels: {
            maxWidth: 400, // Define uma largura máxima para os rótulos
          },
          categories: [],
          tickPlacement: "of",
        },
        title: {
          text: "Top 10 por linhas",
          align: "center",
          margin: 10,
          offsetX: 0,
          offsetY: 0,
          floating: false,
          style: {
            fontSize: "22px",
            fontWeight: "bold",
            color: "#263238",
          },
        },
      },

      /* funcionario    */
      graficoFuncioanrio: {
        chart: {
          id: "bar-funcionario",
          type: "bar",
          height: 350,

          foreColor: "black",
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        xaxis: {
          categories: [],
          tickPlacement: "of",
        },
        title: {
          text: "Top 10 por operadores",
          align: "center",
          margin: 10,
          offsetX: 0,
          offsetY: 0,
          floating: false,
          style: {
            fontSize: "22px",
            fontWeight: "bold",
            color: "#263238",
          },
        },
      },

      /* objetos */

      kpiperiodos: [],
      seriesperiodo: [],
      eventos: [],
      value_eventos: "",
      kpifiliais: [],
      kpidias: [],
      kpifuncionario: [],
      kpidepto: [],
      kpilinha: [],
      dt_inicial: "",
      dt_final: "",
      seriesPizzaFilial: [],
      seriesColunaDia: [],
      seriesdia: [],
      seriesfilial: [],
      seriesfuncionario: [],
      seriesdepto: [],
      serieslinha: [],
      empresa: {},
      empresas: [], // [] lista
      filial: {},
      filiais: [], // [] lista
      solicitacoes: [],
      value_empresa: [], // [this.empresas],
      permissoes: [],
      permissao: {},

      mode: "save",
      isLoading: false,
      value_filial: [],
      value_status: [],
    };
  },

  methods: {
    loadEmpresas() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        psg: this.user.psg,
      };

      const url = `${baseApiUrl}/ctr/empresa`;
      axios.get(url, { params }).then((res) => {
        this.empresas = res.data.map((empresa) => {
          return {
            id_empresa: empresa.id_empresa,
            empresa: empresa.nomeempresarial,
          };
        });
      });
    },

    loadEventos() {
      let params = {
        empresa_id: `${this.empresas.map((e) => e.id_empresa)}`,
        app: true,
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/integracoes/kontrow/eventos`;
      axios.get(url, { params }).then((res) => {
        this.eventos = res.data.map((ev) => {
          return { evento_id: ev.evento_id, evento: ev.evento };
        });
      });
    },

    /// filtros por dia
    loadKpiDia() {
      this.isLoading = true; // Desative o indicador de carregamento
      let params = {
        psg: this.user.psg,
        app: true,
        empresa_id: `${[this.value_empresa.map((e) => e.id_empresa)]}`,
        evento_id: `${[this.value_eventos.map((e) => e.evento_id)]}`,
        dt_inicial_operacao: `${this.dt_inicial_operacao}`,
        dt_final_operacao: `${this.dt_final_operacao}`,
      };
      const url = `${baseApiUrl}/indicadores/kontrow/periodo`;
      axios
        .get(url, { params })
        .then((res) => {
          this.kpidias = res.data;
          this.isLoading = false; // Desative o indicador de carregamento
          this.updateChartDataDia();
        })
        .catch(showError);
    },

    async updateChartDataDia() {
      this.seriesdia = [
        {
          name: "Qtd Eventos",
          data: this.kpidias.map((item) => parseInt(item.qtd)),
        },
      ];
      this.$refs.chartdia.updateOptions({
        xaxis: {
          categories: this.kpidias.map((d) =>
            moment(d.dtevento).format("DD/MM/YYYY")
          ),
        },
      });
    },

    /// filtros por funcionario  21/08/2023
    async loadKpiFuncionario() {
      let params = {
        psg: this.user.psg,
        app: true,
        empresa_id: `${[this.value_empresa.map((e) => e.id_empresa)]}`,
        evento_id: `${[this.value_eventos.map((e) => e.evento_id)]}`,
        dt_inicial_operacao: `${this.dt_inicial_operacao}`,
        dt_final_operacao: `${this.dt_final_operacao}`,
      };
      const url = await `${baseApiUrl}/indicadores/kontrow/operador`;
      axios
        .get(url, { params })
        .then((res) => {
          this.kpifuncionario = res.data;
          this.updateChartDataFuncionario();
        })
        .catch(showError);
    },

    async updateChartDataFuncionario() {
      this.seriesfuncionario = [
        {
          name: "Qtd eventos",
          data: this.kpifuncionario.map((item) => parseInt(item.qtd)),
        },
      ];
      this.$refs.chartfuncionario.updateOptions({
        xaxis: {
          categories: this.kpifuncionario.map((r) => r.registro),
        },
      });
    },

    /// filtros por eventos 06/09/2023
    async loadKpiEventos() {
      let params = {
        psg: this.user.psg,
        app: true,
        empresa_id: `${[this.value_empresa.map((e) => e.id_empresa)]}`,
        evento_id: `${[this.value_eventos.map((e) => e.evento_id)]}`,
        dt_inicial_operacao: `${this.dt_inicial_operacao}`,
        dt_final_operacao: `${this.dt_final_operacao}`,
      };
      const url = await `${baseApiUrl}/indicadores/kontrow/eventos`;
      axios
        .get(url, { params })
        .then((res) => {
          this.kpidepto = res.data;
          this.updateKpiSolicitacaoDepto();
        })
        .catch(showError);
    },

    async updateKpiSolicitacaoDepto() {
      this.seriesdepto = [
        {
          name: "Qtd solicitações",
          data: this.kpidepto.map((item) => parseInt(item.qtd)),
        },
      ];
      this.$refs.chartdepto.updateOptions({
        xaxis: {
          categories: this.kpidepto.map((d) => d.evento),
        },
      });
    },

    /// filtros por linha 06/09/2023
    async loadKpiLinhas() {
      let params = {
        psg: this.user.psg,
        app: true,
        empresa_id: `${[this.value_empresa.map((e) => e.id_empresa)]}`,
        evento_id: `${[this.value_eventos.map((e) => e.evento_id)]}`,
        dt_inicial_operacao: `${this.dt_inicial_operacao}`,
        dt_final_operacao: `${this.dt_final_operacao}`,
      };
      const url = await `${baseApiUrl}/indicadores/kontrow/linhas`;
      axios
        .get(url, { params })
        .then((res) => {
          this.kpilinha = res.data;
          this.updateKpiSolicitacaoLinha();
        })
        .catch(showError);
    },

    async updateKpiSolicitacaoLinha() {
      this.serieslinha = [
        {
          name: "Qtd eventos",
          data: this.kpilinha.map((item) => parseInt(item.qtd)),
        },
      ];
      this.$refs.chartlinha.updateOptions({
        xaxis: {
          categories: this.kpilinha.map((d) => d.linha),
        },
      });
    },
  },

  mounted() {
    this.loadEmpresas();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
</style>